<template lang="pug">
  main.data
    header.header
      main-menu
    section.section
      div.actions-map
        button.search(@click='togglePanel()' v-bind:class="{ open: statusPanel }")
        button(class="flyTo zoomIn btn-map" @click="zoomIn()")
        button(class="flyTo zoomOut btn-map" @click="zoomOut()")
        button(class="flyTo home btn-map" @click="flyTo()")
      div.search-panel(v-bind:class="{ open: statusPanel }")
        h1 search by:
        vue-scrollbar.form--wrapp(ref="scrollbar")
          form(@submit.prevent="filterSearch")
            div.type
              label Instrument Type
              div
                input(
                  type="checkbox"
                  name="drifters"
                  id="typeDrifters"
                  value="drifter"
                  v-model="mapFilters.type"
                  @change="filterType"
                )
                label(for="typeDrifters") drifters
                  span(class="checkmark")
              div
                input(
                  type="checkbox"
                  name="float"
                  value="float"
                  id="typeFloats"
                  v-model="mapFilters.type"
                  @change="filterType"
                )
                label(for="typeFloats") float
                  span(class="checkmark")
              div
                input(
                  type="checkbox"
                  name="gliders"
                  value="glider"
                  id="typeGliders"
                  v-model="mapFilters.type"
                  @change="filterType"
                )
                label(for="typeGliders") gliders
                  span(class="checkmark")
            div.location
                label location
                v-select(
                  ref="locationsSelect",
                  v-model="defaultLoc"
                  :options="locations"
                  @input="filterLocation"
                  :searchable="false"
                )
            div.project
              label project name
              v-select(
                ref="projectsSelect",
                v-model="prjSelected"
                :options="projects"
                @input="filterProjects"
              )
            div.project.deploy(v-if="this.mapFilters.project")
              div.field-deploy
                label Project Deploy
                v-select(
                  ref="projectsDeploy",
                  v-model="deploySelected"
                  :options="deploy"
                  @input="filterProjectsDeploy"
                )
            div.project.id
              label Instrument Id
              v-select(
                ref="typeBoa"
                :disabled="!loadedBoe"
                :options="['WMO', 'IMEI', 'ID']"
                @input="typeIdBoa"
                :searchable="false"
                v-model="typeInstrument"
              )
              v-select(
                v-if="typeId === 'WMO'"
                ref="wmo"
                :disabled="!loadedBoe"
                v-model="boeSelected"
                multiple
                :options="wmo"
                @input="filterBoa"
              )
              v-select(
                v-if="typeId === 'IMEI'"
                ref="imei"
                :disabled="!loadedBoe"
                v-model="boeSelected"
                multiple
                :options="imei"
                @input="filterBoa"
              )
              v-select(
                v-if="typeId === 'ID'"
                ref="boeId"
                :disabled="!loadedBoe"
                v-model="boeSelected"
                multiple
                :options="idBoe"
                @input="filterBoa"
              )
            div.project
              label nationality
              v-select(
                ref="nationalitySelect"
                :disabled="!loadedBoe"
                v-model="nationalitySelected"
                :options="nationality"
                @input="filterNationality"
              )
            div.period
              label period
              div
                input(
                  type="radio"
                  id="last-week"
                  value="last-week"
                  v-model="period"
                  @change="lastWeek"
                )
                label(for="last-week") last week
                  span(class="checkmark radio")
              div
                input(
                  type="radio"
                  id="last-month"
                  value="last-month"
                  v-model="period"
                  @change="lastMonth"
                )
                label(for="last-month") last month
                  span(class="checkmark radio")
              div
                input(
                  type="radio"
                  id="this-year"
                  value="this-year"
                  v-model="period"
                  @change="lastYear"
                )
                label(for="this-year") last year
                  span(class="checkmark radio")
            div.from-to
              div
                label from
                input(
                  type="date"
                  name="dateFrom"
                  id="dateFrom"
                  v-model="mapFilters.date_from"
                  @change="filterDateFrom"
                )
              div
                label to
                input(
                  type="date"
                  name="dateTo"
                  id="dateTo"
                  v-model="mapFilters.date_to"
                  @change="filterDateTo"
                )
            div.actions
              div.numeroboe Total Instruments:
                span(v-if="loadedBoe")  {{ boeSearchCount }}
                div(v-else).spinner
                  div.double-bounce1
                  div.double-bounce2
              div.buttons
                button(
                  class="reset-action search-action"
                  type="button"
                  @click="filterReset()"
                ) Reset
                button(
                  class="search-action search"
                  :disabled="disableSearch()"
                ) view on map
      multipane(
        class="horizontal-panes"
        layout="horizontal"
        @paneResizeStop="paneresizestop"
      )
        div(
          id="map"
          class="pane"
          :class="{ full: statusPanel }"
          :style="{ height: '60%', maxHeight: 'calc(100% - 25px' }")
          v-map(
            ref="map"
            :zoom="zoom"
            :minZoom="minZoom"
            :maxZoom="maxZoom"
            :center="center"
            :bounds="bounds"
            @l-ready="onMapReady"
          )
            v-geojson-layer(
              v-if="markers"
              ref="markers"
              :geojson="markers"
              :options="markersOptions"
            )
            v-geojson-layer(
              v-if="trajectories"
              ref="trajectories"
              :geojson="trajectories"
              :options="trajectoriesOptions"
            )
        multipane-resizer(v-if="!locationsBox")
        div.table-list
          div.controls.columns
            ul.metadata.column
              li.nome-progetto {{ tableCaption  }}
                span  {{ boeCount }}
                |  instruments
                span(v-if="this.instrumentSelected.label") &nbsp model {{ this.instrumentSelected.label }}  &nbsp&nbsp
                span(v-else) &nbsp&nbsp
              li
                span from  {{ fromSelect | ddmmyyyy }} - to {{ toSelect | ddmmyyyy }}
            ul.toggleTable.column
              li(:class="{ active: !tableView }" @click="tableType") localization
              li(:class="{ active: tableView }" @click="tableType") specification
          div.box(v-if="loadedTable")
            v-client-table(
              ref="table"
              class="table-one"
              v-if="boe.length && !tableView"
              :data="boe"
              :columns="table.columns"
              :options="table.options"
            )
              i(
                slot="select"
                slot-scope="props"
                class="show"
                @click="viewMarker($event, props.row.id_boa)"
              )
                span go to
              div(slot="h__hide" slot-scope="props" class="form-all")
                input( type="checkbox" @change="hideAll($event)")
                div Hide
              i(slot="hide" slot-scope="props" class="hidden")
                input(
                  type="checkbox"
                  :id="`hidden-${props.row.id_boa}`"
                  :value="props.row.id_boa"
                  v-model="hiddenId"
                  @click="hiddenMarker($event, props.row.id_boa)"
                )
                label(class="hidden" :for="`hidden-${props.row.id_boa}`")
              div(slot="h__trj" slot-scope="props" class="form-all")
                input( type="checkbox" @change="trjAll($event)")
                div tracks
              i(slot="trj" slot-scope="props")
                input(
                  type="checkbox"
                  :id="`trj-${props.row.id_boa}`"
                  :value="props.row.id_boa"
                  v-model="trjId"
                  @click="trjMarker($event, props.row.type, props.row.id_boa)"
                )
                label(class="trj" :for="`trj-${props.row.id_boa}`")
              i(
                slot="type"
                slot-scope="props"
                :class="props.row.type"
              )
                span {{ props.row.type }}
              div(slot="h__kml" slot-scope="props" class="form-all")
                i(class="kml kml--all" @click="getAllKml")
                div kml
              i(
                slot="kml"
                slot-scope="props"
                class="kml"
                @click="getKml($event, props.row.id_boa, props.row.type)"
              )
              i(
                slot="status"
                slot-scope="props"
                :class="`status-${props.row.status}`"
              )
                span {{ props.row.status }}
              span(
                slot="wmo"
                slot-scope="props"
                v-html="props.row.wmo"
              )
              span(
                slot="deployment_time"
                slot-scope="props"
              ) {{ props.row.deployment_time | ddmmyyyyhmm }}
              span(
                slot="transmission_last_date"
                slot-scope="props"
              ) {{ props.row.transmission_last_date | ddmmyyyyhmm }}
            v-client-table(
              ref="tableBonus"
              class="table-bonus"
              v-if="boe.length && tableView"
              :data="boe"
              :columns="table.columnsbis"
              :options="table.options"
            )
              i(
                slot="select"
                slot-scope="props"
                class="show"
                @click="viewMarker($event, props.row.id_boa)"
              )
                span go to
              div(slot="h__hide" slot-scope="props" class="form-all")
                input( type="checkbox" @change="hideAll($event)")
                div Hide
              i(slot="hide" slot-scope="props" class="hidden")
                input(
                  type="checkbox"
                  :id="`hidden-${props.row.id_boa}`"
                  :value="props.row.id_boa"
                  v-model="hiddenId"
                  @click="hiddenMarker($event, props.row.id_boa)"
                )
                label(class="hidden" :for="`hidden-${props.row.id_boa}`")
              div(slot="h__trj" slot-scope="props" class="form-all")
                input( type="checkbox" @change="trjAll($event)")
                div path
              i(slot="trj" slot-scope="props")
                input(
                  type="checkbox"
                  :id="`trj-${props.row.id_boa}`"
                  :value="props.row.id_boa"
                  v-model="trjId"
                  @click="trjMarker($event, props.row.type, props.row.id_boa)"
                )
                label(class="trj" :for="`trj-${props.row.id_boa}`")
              i(
                slot="type"
                slot-scope="props"
                :class="props.row.type"
              )
                span {{ props.row.type }}
              div(slot="h__kml" slot-scope="props" class="form-all")
                i(class="kml kml--all" @click="getAllKml")
                div kml
              i(
                slot="kml"
                slot-scope="props"
                class="kml"
                @click="getKml($event, props.row.id_boa, props.row.type)"
              )
              i(
                slot="status"
                slot-scope="props"
                :class="`status-${props.row.status}`"
              )
                span {{ props.row.status }}
              div(
                slot="wmo"
                slot-scope="props"
                v-html="props.row.wmo"
              )
              span(
                slot="deployment_time"
                slot-scope="props"
              ) {{ props.row.deployment_time | ddmmyyyyhmm }}
              span(
                slot="transmission_last_date"
                slot-scope="props"
              ) {{ props.row.transmission_last_date | ddmmyyyyhmm }}
          div(v-else).spinner
            div.double-bounce1
            div.double-bounce2
      div.box-overlay(v-if="locationsBox")
        div.container
          h1 OUR DATA
            span(v-if="prjLocator.active")  for {{ tableCaption }}
          div.intro(v-html="settings.sections.data.intro")
          h2 select the area
          br
          div.tiles
            a.tile(@click="loadLocator(5, mediterraneanSea.sum)" :class="{empty:mediterraneanSea.sum < 1}")
              h2(v-if="!prjLocator.active") Last 30 days data
              div
                p {{ mediterraneanSea.sum}}
                  span Total Instruments
                h1 {{ mediterraneanSea.area }}
                a(v-if="mediterraneanSea.sum > 0")
                  span
                  | explore area
            a.tile(@click="loadLocator(18, blackSea.sum)")
              h2(v-if="!prjLocator.active") Last 30 days data
              div
                p {{ blackSea.sum }}
                  span Total Instruments
                h1 {{ blackSea.area }}
                a(v-if="blackSea.sum > 0")
                  span
                  | explore area
            a.tile(@click="loadLocator(2, atlanticOcean.sum)" :class="{empty:atlanticOcean.sum < 1}")
              h2(v-if="!prjLocator.active") Last 30 days data
              div
                p {{ atlanticOcean.sum }}
                  span Total Instruments
                h1 {{ atlanticOcean.area }}
                a(v-if="atlanticOcean.sum > 0")
                  span
                  | explore area
            a.tile(@click="loadLocator(19, antarcticArea.sum)")
              h2(v-if="!prjLocator.active") Last 30 days data
              div
                p {{ antarcticArea.sum }}
                  span Total Instruments
                h1 {{ antarcticArea.area }}
                a(v-if="antarcticArea.sum > 0")
                  span
                  | explore area
</template>
<script>
import Vue from 'vue'
// import axios from 'axios'
import { mapState } from 'vuex'
import MainMenu from '@/components/MainMenu.vue'
import { Multipane, MultipaneResizer } from 'vue-multipane'
import VueScrollbar from 'vue2-scrollbar'
// https://sagalbot.github.io/vue-select/docs/
import VueSelect from 'vue-select'
// https://momentjs.com/
import moment from 'moment'
// GIS
import L from 'leaflet'
import { dynamicMapLayer } from 'esri-leaflet'
import Proj from 'proj4leaflet'
import PopupContent from '@/components/PopupContent'
import Vue2Leaflet from 'vue2-leaflet'
// import FreeDraw from 'leaflet-freedraw'
import { MARKERICON } from '@/utils'

// const freeDraw = new FreeDraw()

export default {
  name: 'dataView',
  metaInfo: {
    title: 'Data'
  },
  components: {
    'main-menu': MainMenu,
    'v-select': VueSelect,
    'v-map': Vue2Leaflet.Map,
    'v-geojson-layer': Vue2Leaflet.GeoJSON,
    'multipane': Multipane,
    'multipane-resizer': MultipaneResizer,
    VueScrollbar
  },
  computed: {
    ...mapState({
      settings: 'settings',
      locationsBox: 'locationsBox',
      home_data: 'home_data',
      boeSearch: 'boeSearch',
      mapFilters: 'mapFilters',
      rengeMarkers: 'rengeMarkers',
      trajectories: 'trajectories',
      loadedBoe: 'loadedBoe',
      loadedTable: 'loadedTable'
    }),
    markers () {
      return this.$store.getters.markers
    },
    instrumentsFilter () {
      return this.$store.getters.instrumentsFilter
    },
    locations () {
      return this.$store.getters.selectLocations
    },
    projects () {
      return this.$store.getters.selectProjects
    },
    project () {
      return this.$store.getters.project
    },
    nationality () {
      return this.$store.getters.nationality
    },
    wmo () {
      return this.$store.getters.wmo
    },
    imei () {
      return this.$store.getters.imei
    },
    idBoe () {
      return this.$store.getters.idBoe
    },
    boeCount () {
      return this.$store.getters.boeCount
    },
    boeSearchCount () {
      return this.$store.getters.boeSearchCount
    },
    boe () {
      return this.$store.getters.boe
    },
    antarcticArea () {
      if (this.prjLocator.active && this.prjLocator.location) {
        const area = this.prjLocator.location.filter(l => l.id === 19)[0]
          ? this.prjLocator.location.filter(l => l.id === 19)[0].name
          : this.home_data.boe_per_oceano_last_month['19'].area
        const sum = this.prjLocator.location.filter(l => l.id === 19)[0]
          ? this.prjLocator.location.filter(l => l.id === 19)[0].total
          : 0
        const item = {
          sum: sum,
          area: area
        }
        return item
      } else {
        return this.home_data.boe_per_oceano_last_month['19']
      }
    },
    mediterraneanSea () {
      if (this.prjLocator.active && this.prjLocator.location) {
        const area = this.prjLocator.location.filter(l => l.id === 5)[0]
          ? this.prjLocator.location.filter(l => l.id === 5)[0].name
          : this.home_data.boe_per_oceano_last_month['5'].area
        const sum = this.prjLocator.location.filter(l => l.id === 5)[0]
          ? this.prjLocator.location.filter(l => l.id === 5)[0].total
          : 0
        const item = {
          sum: sum,
          area: area
        }
        return item
      } else {
        return this.home_data.boe_per_oceano_last_month['5']
      }
    },
    blackSea () {
      if (this.prjLocator.active && this.prjLocator.location) {
        const area = this.prjLocator.location.filter(l => l.id === 18)[0]
          ? this.prjLocator.location.filter(l => l.id === 18)[0].name
          : this.home_data.boe_per_oceano_last_month['18'].area
        const sum = this.prjLocator.location.filter(l => l.id === 18)[0]
          ? this.prjLocator.location.filter(l => l.id === 18)[0].total
          : 0
        const item = {
          sum: sum,
          area: area
        }
        return item
      } else {
        return this.home_data.boe_per_oceano_last_month['18']
      }
    },
    atlanticOcean () {
      if (this.prjLocator.active && this.prjLocator.location) {
        const area = this.prjLocator.location.filter(l => l.id === 2)[0]
          ? this.prjLocator.location.filter(l => l.id === 2)[0].name
          : this.home_data.boe_per_oceano_last_month['2'].area
        const sum = this.prjLocator.location.filter(l => l.id === 2)[0]
          ? this.prjLocator.location.filter(l => l.id === 2)[0].total
          : 0
        const item = {
          sum: sum,
          area: area
        }
        return item
      } else {
        return this.home_data.boe_per_oceano_last_month['2']
      }
    }
  },
  data () {
    return {
      trjId: [],
      deploy: [],
      hiddenId: [],
      tableCaption: 'Selection',
      tableView: false,
      statusPanel: false,
      boeSelected: [],
      typeId: '',
      typeInstrument: 'WMO',
      table: {
        theme: 'bulma',
        columns: ['select', 'hide', 'trj', 'type', 'id_boa', 'wmo', 'imei', 'kml', 'deployment_time', 'lat', 'lon', 'transmission_last_date', 'last_lat', 'last_lon', 'mission_days'],
        columnsbis: ['select', 'hide', 'trj', 'type', 'id_boa', 'wmo', 'imei', 'kml', 'country_www', 'cycle', 'oceano_name', 'generic', 'depth', 'tipo_det', 'status_tx'],
        options: {
          orderBy: {
            column: 'deployment_time'
          },
          sortable: ['type', 'id_boa', 'wmo', 'imei', 'deployment_time', 'lat', 'lon', 'transmission_last_date', 'last_lat', 'last_lon', 'mission_days', 'country_www', 'cycle', 'oceano_name', 'generic', 'depth', 'tipo_det', 'status_tx'],
          perPage: 1000,
          columnsClasses: {
            status: 'status'
          },
          pagination: { dropdown: false },
          headings: {
            select: 'go to',
            id_boa: 'id',
            tipo_det: 'transmission',
            generic: 'model',
            country_www: 'country',
            oceano_name: 'location',
            lat: 'deploy lat',
            lon: 'deploy lon',
            deployment_time: 'deploy date',
            transmission_last_date: 'last date',
            latitude: 'last_lat',
            longitude: 'last_lon',
            mission_days: 'mission days'
          },
          rowClassCallback (row) {
            return row.selected
          },
          customSorting: {
            // tmp mettiamo number nell'API?
            depth: function (ascending) {
              return function (a, b) {
                const lastA = parseInt(a.id_boa, 10)
                const lastB = parseInt(b.id_boa, 10)
                if (ascending) {
                  return lastA >= lastB ? 1 : -1
                } else {
                  return lastA <= lastB ? 1 : -1
                }
              }
            },
            id_boa: function (ascending) {
              return function (a, b) {
                const lastA = parseInt(a.id_boa, 10)
                const lastB = parseInt(b.id_boa, 10)
                if (ascending) {
                  return lastA >= lastB ? 1 : -1
                } else {
                  return lastA <= lastB ? 1 : -1
                }
              }
            }
          }
        }
      },
      period: '',
      defaultLoc: null,
      prjSelected: null,
      deploySelected: null,
      instrumentSelected: {
        label: null
      },
      nationalitySelected: null,
      fromSelect: '1996-04-01',
      toSelect: '1996-04-01',
      extent: true,
      prjLocator: {
        active: false,
        location: []
      },
      bounds: L.latLngBounds(),
      bathyLayer: L.tileLayer('http://services.arcgisonline.com/ArcGIS/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}',
        {
          attribution: 'Esri, Garmin, GEBCO, NOAA NGDC, and other contributors',
          crs: L.CRS.EPSG3857
        }
      ),
      antarticaLayer: dynamicMapLayer({
        url: 'https://maps.units.it/arcgis/rest/services/Antartis/antapub_bg_full/MapServer/',
        opacity: 1
      }),
      antarticCRS: new Proj.CRS(
        'EPSG:3031',
        '+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs',
        {
          resolutions: [
            16933.367200067736, 8466.683600033868, 4233.341800016934, 2116.670900008467, 1058.3354500042335, 529.1677250021168, 264.5838625010584, 132.2919312505292
          ],
          origin: [-2.0E7, 1.9E7]
        }
      ),
      center: [17.245, 17.139],
      zoom: 0,
      minZoom: 0,
      maxZoom: 10,
      markersOptions: {
        pointToLayer: function (feature, latlng) {
          return L.marker(latlng, {icon: MARKERICON(feature.properties)})
        },
        onEachFeature: (feature, layer) => {
          let Popup = Vue.extend(PopupContent)
          let popup = new Popup({
            store: this.$store,
            propsData: { data: feature }
          })
          // bind click
          layer.on({ click: this.onGeoJsonClick.bind(this) })
          layer.on({ popupclose: this.popUpClose.bind(this) })
          layer.bindPopup(popup.$mount().$el)
        }
      },
      trajectoriesOptions: {
        style: (feature) => {
          return { color: feature.properties.stroke }
        },
        onEachFeature: (feature, layer) => {
          let Popup = Vue.extend(PopupContent)
          let popup = new Popup({
            store: this.$store,
            propsData: { data: feature }
          })
          // bind click
          layer.on({ click: this.onGeoJsonClick.bind(this) })
          layer.on({ popupclose: this.popUpClose.bind(this) })
          layer.bindPopup(popup.$mount().$el)
        }
      }
    }
  },
  created () {
    this.$store.commit('CLEAR_TRAJECTORIES')
  },
  mounted () {
    // this.extent = true
    this.prjLocator.active = false
    this.init()
    this.$store.dispatch('LOAD_HOME_DATA')
    this.$store.dispatch('LOAD_LOCATIONS_LIST')
    this.$store.dispatch('LOAD_FILTER_PROJECT_LIST', this.parameters(this.mapFilters))
  },
  watch: {
    'markers': function (g) {
      if (g && g.hasOwnProperty('features') && g.features.length && this.extent) {
        this.flyTo()
      }
    }
  },
  methods: {
    init () {
      if (this.mapFilters.location || this.mapFilters.instrument || this.mapFilters.project || this.mapFilters.deployment) {
        this.renderData(this.mapFilters)
      }
    },
    renderData (filters) {
      this.defaultLoc = this.locations.filter(l => parseInt(l.id, 10) === parseInt(filters.location, 10))[0]
      if (filters.project && filters.location) {
        const projectSelect = this.$store.getters.project
        this.$nextTick(function () {
          this.prjSelected = {
            id: projectSelect.id_project,
            value: filters.project,
            label: projectSelect.name || '',
            date_start: filters.date_from,
            date_end: filters.date_to,
            id_oceano: filters.location,
            deployments: projectSelect.deployments
          }
          this.tableCaption = projectSelect.name
          this.$store.state.locationsBox = false
          this.prjLocator.active = false
          this.prjLocator.location = projectSelect.location
          this.mygeojson()
          this.loadBoe('table')
          this.loadBoe('list')
        })
      } else if (filters.deployment) {
        const projectSelect = this.$store.getters.project
        this.$nextTick(() => {
          this.prjSelected = {
            id: projectSelect.id_project,
            value: filters.project,
            label: projectSelect.name || '',
            date_start: filters.date_from,
            date_end: filters.date_to,
            id_oceano: filters.location,
            deployments: projectSelect.deployments
          }
          this.tableCaption = projectSelect.name
          this.$store.state.locationsBox = this.prjLocator.active = false
          this.mygeojson()
          this.loadBoe('table')
          this.loadBoe('list')
        })
      } else if (filters.project) {
        this.prjLocator.active = true
        this.prjLocator.location = this.project.location
        this.$nextTick(function () {
          this.tableCaption = this.project.name
          this.$store.state.locationsBox = true
        })
      } else if (this.mapFilters.location) {
        this.$store.commit('SET_MAP_FILTERS', {
          location: filters.location || null,
          dateFrom: moment().subtract(30, 'days').format('YYYY-MM-DD'),
          dateTo: moment().format('YYYY-MM-DD'),
          nationality: 'ITALY'
        })
        this.nationalitySelected = 'ITALY'
        this.mygeojson()
        this.loadBoe('table')
        this.loadBoe('list')
        this.$store.state.locationsBox = false
      } else if (this.mapFilters.instrument) {
        this.nationalitySelected = 'ITALY'
        this.mapFilters.date_from = '1986-01-01'
        this.mapFilters.date_to = moment().format('YYYY-MM-DD')
        this.$store.state.locationsBox = false
        this.instrumentSelected = this.instrumentsFilter.filter(i => i.value.toString() === this.mapFilters.instrument.toString())[0]
        this.mygeojson()
        this.loadBoe('table')
        this.loadBoe('list')
      }
    },
    loadLocator (location, boe) {
      if (parseInt(boe, 10) === 0) return false
      if (this.mapFilters.project) {
        this.$store.commit('SET_MAP_FILTERS', {
          location: location,
          type: ['drifter', 'float', 'glider'],
          dateFrom: this.project.date_start,
          dateTo: this.project.date_end_phy || moment().format('YYYY-MM-DD'),
          project: this.project.id_project
        })

        // set project form select
        this.prjSelected = {
          id: this.project.id_project,
          label: this.project.name || '',
          value: this.project.name || '',
          date_start: this.project.date_start,
          date_end: this.project.date_end_phy || moment().format('YYYY-MM-DD'),
          id_oceano: location
        }
        this.mygeojson()
        this.loadBoe('table')
        this.loadBoe('list')
        this.$store.state.locationsBox = false
      } else {
        this.$store.commit('SET_MAP_FILTERS', {
          location: location,
          dateFrom: moment().subtract(30, 'days').format('YYYY-MM-DD'),
          dateTo: moment().format('YYYY-MM-DD'),
          nationality: 'ITALY'
        })
        this.defaultLoc = this.locations.filter(l => parseInt(l.id, 10) === parseInt(location, 10))[0]
        this.nationalitySelected = 'ITALY'
        this.mygeojson()
        this.loadBoe('table')
        this.loadBoe('list')
        this.$store.dispatch('LOAD_FILTER_PROJECT_LIST', this.parameters(this.mapFilters))
        this.$store.state.locationsBox = false
      }
      this.chooseBaseMap()
    },
    mygeojson () {
      const CLONE = Object.assign({}, this.mapFilters)
      this.tableCaption = this.prjSelected ? this.prjSelected.label : 'Selection'
      this.$store.dispatch('LOAD_MARKERS', this.parameters(CLONE))
    },
    onGeoJsonClick ({target}) {
      const table = this.tableView ? this.$refs.tableBonus : this.$refs.table
      table.data.forEach(item => {
        item.selected = item.id_boa === target.feature.properties.id ? 'selected' : 'no-selected'
      })
    },
    popUpClose ({target}) {
      const table = this.tableView ? this.$refs.tableBonus : this.$refs.table
      table.data.forEach(item => {
        if (item.id_boa === target.feature.properties.id) {
          item.selected = 'no-selected'
        }
      })
      // deselect checkbox trj
      if (target.feature.properties.delete) {
        this.trjId.splice(this.trjId.indexOf(target.feature.properties.id), 1)
      }
    },
    loadBoe (type) {
      const CLONE = Object.assign({}, this.mapFilters)
      this.fromSelect = CLONE.date_from
      this.toSelect = CLONE.date_to
      this.$store.dispatch('LOAD_BOE_LIST', [this.parameters(CLONE), type])
    },
    togglePanel () {
      this.statusPanel = !this.statusPanel
      if (this.statusPanel) {
        // remove resize map
        this.$el.querySelector('#map').setAttribute('style', 'height: 60%;max-height: calc(100% - 25px);')
        this.searchBoe()
      }
      setTimeout(() => {
        // trick to wait for height change
        this.paneresizestop()
        // this.$refs.map.mapObject.setZoom(this.$refs.map.mapObject.getZoom())
      }, 700)
    },
    searchBoe () {
      if (this.statusPanel) {
        // this.loadBoe('count')
        this.disableSearch()
        this.mapFilters.instrument = null
        this.instrumentSelected.label = null
      }
    },
    filterType () {
      this.$store.dispatch('LOAD_INSTRUMENTS_FILTER_LIST', this.parameters(this.mapFilters))
      this.boeListReset()
      this.searchBoe()
    },
    filterLocation (location) {
      if (this.statusPanel) {
        if (location === null) {
          this.mapFilters.location = null
          this.prjSelected = null
        } else if (location.hasOwnProperty('id')) {
          this.mapFilters.location = location.id
          if (!this.prjLocator.active) {
            this.prjSelected = null
            this.mapFilters.date_from = '1986-01-01'
            this.mapFilters.date_to = moment().format('YYYY-MM-DD')
          }
        }
        this.mapFilters.deployment = this.deploySelected = this.period = null
        this.$store.dispatch('LOAD_FILTER_PROJECT_LIST', this.parameters(this.mapFilters))
        this.boeListReset()
        this.searchBoe()
      }
    },
    filterProjects (project) {
      this.mapFilters.deployment = null
      if (project === null) {
        this.prjLocator.active = false
        this.mapFilters.project = null
        this.mapFilters.date_from = '1986-01-01'
        this.mapFilters.date_to = moment().format('YYYY-MM-DD')
        this.boeListReset()
        this.searchBoe()
      } else if (project.hasOwnProperty('id')) {
        if (parseInt(project.id, 10) !== parseInt(this.project.id_project, 10)) {
          this.prjLocator.active = false
        }
        const location = this.$refs.locationsSelect.options.filter(l => parseInt(l.id, 10) === parseInt(project.id_oceano, 10))[0]
        this.defaultLoc = location
        this.mapFilters.location = project.id_oceano
        this.mapFilters.project = project.id
        this.mapFilters.date_from = project.date_start
        this.mapFilters.date_to = project.date_end ? project.date_end : moment().format('YYYY-MM-DD')
        this.boeListReset()
        this.searchBoe()
        this.loadDeploySelect(project)
      }
      this.period = null
      this.deploySelected = null
    },
    loadDeploySelect (project) {
      if (project === null) {
        return false
      }
      if (project.hasOwnProperty('deployments')) {
        this.deploy = project.deployments.map((item) => {
          return {
            label: item.deploy.date ? item.deploy.date.toString() : 'undefined',
            value: item.deploy.id || 'undefined'
          }
        })
      }
    },
    filterProjectsDeploy (deploy) {
      if (deploy === null) {
        this.mapFilters.deployment = null
      } else {
        this.mapFilters.deployment = deploy.value
      }
      this.boeListReset()
      this.searchBoe()
    },
    filterInstruments (instruments) {
      if (instruments === null) {
        this.mapFilters.instrument = null
      } else {
        this.mapFilters.instrument = instruments.value
      }
      this.boeListReset()
      this.searchBoe()
    },
    filterNationality (nationality) {
      if (this.statusPanel) {
        this.mapFilters.nationality = nationality
        this.boeListReset()
        this.searchBoe()
      }
    },
    filterBoa (boa) {
      if (boa && boa.length) {
        if (this.typeId === 'WMO') {
          this.mapFilters.wmo = boa.join()
        } else if (this.typeId === 'IMEI') {
          this.mapFilters.imei = boa.join()
        } else if (this.typeId === 'ID') {
          this.mapFilters.id = boa.join()
        }
        // this.loadBoe('list')
        this.searchBoe()
      } else if (!this.$store.state.locationsBox) {
        this.mapFilters.wmo = this.mapFilters.id = this.mapFilters.imei = null
        // this.loadBoe('list')
        this.searchBoe()
      }
    },
    typeIdBoa (type) {
      this.typeId = type
      this.boeSelected = []
      this.mapFilters.id = this.mapFilters.wmo = this.mapFilters.imei = null
      this.filterBoa()
    },
    filterDateFrom () {
      this.period = null
      this.boeListReset()
      this.searchBoe()
    },
    filterDateTo () {
      this.period = null
      this.boeListReset()
      this.searchBoe()
    },
    lastWeek () {
      this.mapFilters.date_from = moment().subtract(7, 'days').format('YYYY-MM-DD')
      this.mapFilters.date_to = moment().format('YYYY-MM-DD')
      this.boeListReset()
      this.searchBoe()
    },
    lastMonth () {
      this.mapFilters.date_from = moment().subtract(30, 'days').format('YYYY-MM-DD')
      this.mapFilters.date_to = moment().format('YYYY-MM-DD')
      this.boeListReset()
      this.searchBoe()
    },
    lastYear () {
      this.mapFilters.date_from = moment().subtract(365, 'days').format('YYYY-MM-DD')
      this.mapFilters.date_to = moment().format('YYYY-MM-DD')
      this.boeListReset()
      this.searchBoe()
    },
    parameters (f) {
      var str = ''
      for (var key in f) {
        if (str !== '') {
          str += '&'
        }
        str += key + '=' + f[key]
      }
      return str
    },
    filterSearch () {
      this.togglePanel()
      this.$store.commit('CLEAR_TRAJECTORIES')
      this.trjId = []
      this.mygeojson()
      this.loadBoe('table')
      this.chooseBaseMap()
    },
    chooseBaseMap () {
      if (parseInt(this.mapFilters.location, 10) === 19) {
        this.antarcticMap()
      } else {
        this.defaultMap()
      }
    },
    boeListReset () {
      if (this.statusPanel) {
        this.boeSelected = []
        this.mapFilters.id = this.mapFilters.wmo = this.mapFilters.imei = null
        this.loadBoe('list')
      }
    },
    filterReset () {
      this.period = null
      this.$store.commit('RESET_MAP_FILTERS')
      this.typeInstrument = 'WMO'
      this.boeListReset()
      this.$refs.projectsSelect.clearSelection()
      this.$refs.locationsSelect.clearSelection()
      this.$refs.nationalitySelect.clearSelection()
    },
    onMapReady () {
      const MAP = this.$refs.map.mapObject
      MAP.removeControl(MAP.zoomControl)
      this.chooseBaseMap()
      MAP.on('click', e => {
        console.log('latlng', e.latlng)
        console.log('Bounds', MAP.getBounds())
      })
      L.control.scale({
        imperial: false
      }).addTo(MAP)
      // this.flyTo()
      // add free draw tool
      // this.$refs.map.mapObject.addLayer(freeDraw)
    },
    flyTo () {
      const MAP = this.$refs.map.mapObject
      const MARKERS = L.geoJson(this.markers)
      if (MARKERS && '_northEast' in MARKERS.getBounds()) {
        MAP.flyToBounds(MARKERS.getBounds(), {
          paddingTopLeft: [0, 0]
        })
      }
    },
    zoomIn () {
      this.$refs.map.mapObject.zoomIn()
    },
    zoomOut () {
      this.$refs.map.mapObject.zoomOut()
    },
    defaultMap () {
      this.extent = true
      const MAP = this.$refs.map.mapObject
      MAP.options.crs = L.CRS.EPSG3857
      this.bathyLayer.addTo(MAP)
      MAP.removeLayer(this.antarticaLayer)
      this.flyTo()

      MAP.options.minZoom = 2
    },
    antarcticMap () {
      this.extent = false
      const MAP = this.$refs.map.mapObject

      MAP.options.crs = this.antarticCRS

      this.bounds = L.latLngBounds(L.latLng(1.6536767015385645, -110.59222150254793), L.latLng(5.568379418956313, 71.29421299786227))

      this.antarticaLayer.addTo(MAP)
      MAP.removeLayer(this.bathyLayer)

      MAP.options.minZoom = 0
    },
    viewMarker (event, id) {
      const BOA = this.markers.features.filter(point => point.properties.id.toString() === id.toString())
      if (BOA.length) {
        BOA[0].properties.selected = 'status-selected'
        const SELECTED = BOA.map((element) => {
          return {
            lon: element.geometry.coordinates[0],
            lat: element.geometry.coordinates[1]
          }
        })[0]
        this.$refs.map.mapObject.flyTo(SELECTED, 9)
        // remove boa selected
        setTimeout(function () {
          BOA[0].properties.selected = 'no-selected'
        }, 12000)
      } else {
        console.log('No marker in the map!')
      }
    },
    getKml (event, id, type) {
      const API = `http://maosapi.inogs.it/v0.1/kml-all?${type}=${id}&single=true&type=${type}`
      window.location.href = API
      /*
      axios.get(`http://maos.inogs.it/interfase/api/v0.1/kml-all?${type}=${id}&single=true&type=${type}`)
        .then(function (response) {
          console.log(response)
        })
        .catch(function (error) {
          console.log(error)
        })
      */
    },
    getAllKml (id) {
      const float = this.boe.filter(b => b.type === 'float').map(boa => boa.id_boa).toString() || null

      const drifter = this.boe.filter(b => b.type === 'drifter').map(boa => boa.id_boa).toString() || null
      // const glider = this.boe.filter(b => b.type === 'glider').map(boa => boa.id_boa.split(/\s*-\s*/)[0]).toString() || null

      const glider = this.boe.filter(b => b.type === 'glider').map(boa => boa.id_boa).toString() || null

      const API = `http://maosapi.inogs.it/v0.1/kml-all?float=${float}&drifter=${drifter}&glider=${glider}`

      console.log('All KML API ', API)
      window.location.href = API
    },
    hiddenMarker (event, type) {
      const ID = event.target.value.toString()
      const MARKERS = this.markers.features
      const BOA = MARKERS.filter(point => point.properties.id.toString() === ID.toString())
      if (event.target.checked) {
        BOA[0].properties.hidden = 'hidden'
      } else {
        BOA[0].properties.hidden = 'no-hidden'
      }
    },
    trjMarker (event, type, id) {
      const ID = id.toString()
      if (event.target.checked) {
        this.$store.dispatch('LOAD_TRAJECTORY', `type=${type}&id=${ID}&date_from=${this.mapFilters.date_from}&date_to=${this.mapFilters.date_to}`).then(response => {
          const selected = response.data.features.filter(t => t.properties.id.toString() === ID)
          const geojsonLayer = L.geoJson(selected)
          if (this.mapFilters.location === 19) {
            return false
          } else {
            this.$refs.map.mapObject.fitBounds(geojsonLayer.getBounds())
          }
        })
      } else {
        this.$store.commit('UNSET_TRAJECTORY', ID)
      }
    },
    hideAll (event) {
      if (event.target.checked) {
        const hiddenId = []
        this.markers.features.forEach((m) => {
          m.properties.hidden = 'hidden'
          hiddenId.push(m.properties.id)
        })
        this.hiddenId = hiddenId
      } else {
        this.markers.features.forEach((m) => {
          m.properties.hidden = 'no-hidden'
        })
        this.hiddenId = []
      }
    },
    trjAll (event) {
      let breakLoop = false
      if (event.target.checked) {
        const trjId = []
        breakLoop = false
        this.markers.features.some((m) => {
          trjId.push(m.properties.id)
          this.$store.dispatch('LOAD_TRAJECTORY', `type=${m.properties.type}&id=${m.properties.id}&date_from=${this.mapFilters.date_from}&date_to=${this.mapFilters.date_to}`)
          // break when the callback returns true (@breakLoop)
          return breakLoop
        })
        this.trjId = trjId
      } else {
        breakLoop = true
        this.trajectories.features = []
        this.$store.commit('CLEAR_TRAJECTORIES')
        this.trjId = []
      }
    },
    paneresizestop () {
      this.$refs.map.mapObject.invalidateSize()
    },
    tableType () {
      this.tableView = !this.tableView
    },
    disableSearch () {
      if (this.boeSearchCount <= 0 || !this.mapFilters.date_from || !this.mapFilters.date_to || !this.loadedBoe) {
        return true
      } else {
        return false
      }
    },
    resetMapFilters () {
      this.$store.commit('SET_MAP_FILTERS', {
        location: null,
        type: ['drifter', 'float', 'glider'],
        dateFrom: moment().subtract(3, 'days').format('YYYY-MM-DD'),
        dateTo: moment().format('YYYY-MM-DD'),
        project: null,
        instrument: null,
        deployment: null
      })
      this.$store.state.locationsBox = true
    },
    handleScroll (event) {
      console.log('event', event)
    }
  },
  filters: {
    ddmmyyyyhmm: function (date) {
      return moment(date).format('DD/MM/YYYY H:mm')
    },
    ddmmyyyy: function (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  },
  destroyed () {
    if (this.boe.length === 0 || this.mapFilters.project !== null) {
      this.resetMapFilters()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .data .navbar {
    background-color: rgba(83, 118, 163, 0.9);
  }

  .data .section button.btn-map {
    position: relative;
    right: inherit;
    display: block;
    margin: .5em 0;
  }

  .form--wrapp {
    background-color: transparent;
    height: calc(100% - 148px);
  }

  .data .section .search-panel form button.search-action:disabled {
    background: #dddddd;
    cursor: inherit;
  }

  .table-list {
    .spinner {
      top: 50%;
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/Data.vue